/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

// Automatically includes JS from the /components dirctory
import autoTemplateComponent from './core/auto-template-component'
import menu from './utilities/menu'
import mobileMenu from './utilities/mobile-menu'
import modal from './utilities/modal'
import video from './utilities/video-modal'
import contents from './utilities/contents'
import timeline from './utilities/timeline'
import ajaxFilter from './utilities/ajax'
import scrollProgress from './utilities/progress-line'
import localTime from './utilities/local-time'

window.addEventListener('DOMContentLoaded', () => {
  autoTemplateComponent()
  menu()
  mobileMenu()
  modal()
  video()
  contents()
  timeline()
  ajaxFilter()
  scrollProgress()
  localTime()
})
